import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Cnab } from 'src/app/models/financeiro/cnab.model';
import { URL_GLOBAL } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class HomeService {

    // UrlCnab = 'https://madelife.med.br:9025/api/Cnab';
    dataObservable: Observable<any>;
    observer: any;
    constructor(private http: HttpClient) {
        this.dataObservable = new Observable((observer) => {
            this.observer = observer;
        })
    }

    getDados(token,pages) {
        const headers = new HttpHeaders({
            'Authorization': token["token_type"] + " " + token.access_token
        });
        return this.http.get<any>(`${URL_GLOBAL}/web/home/dashboard/get_dados?ocorrencias=${pages.ocorrencias}&tipo=${pages.tipo}&prestador=${pages.prestador}&responsavel=${pages.responsavel}&paciente=${pages.paciente}&chamados_enfermagem=${pages.chamados_enfermagem}&chamados_ti=${pages.chamados_ti}&inicio=${pages.inicio}&fim=${pages.fim}`,{ headers });
    }

    getOcorrenciasResolvidas(token,pages) {
        const headers = new HttpHeaders({
            'Authorization': token["token_type"] + " " + token.access_token
        });
        return this.http.get<any>(`${URL_GLOBAL}/web/home/dashboard/get_ocorrencias_resolvidas?ocorrencias=${pages.ocorrencias}&tipo=${pages.tipo}&prestador=${pages.prestador}&responsavel=${pages.responsavel}&paciente=${pages.paciente}&inicio=${pages.inicio}&fim=${pages.fim}`,{ headers });
    }


    resolver_ocorrencia(token: any, data: any): Observable<any> {
        const headers = new HttpHeaders({
            'Authorization': token["token_type"] + " " + token.access_token
        });
        return this.http.post<any>(`${URL_GLOBAL}/web/home/dashboard/resolver_ocorrencia`, data, { headers });
    }


    getPendencias(token) {
        const headers = new HttpHeaders({
            'Authorization': token["token_type"] + " " + token.access_token
        });
        return this.http.get<any>(`${URL_GLOBAL}/web/home/dashboard/get_pendencias`,{ headers });
    }

    
}
